import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Report } from '../../../models/report.model';
import { PSelectItem } from '../../../../shared/design-system/atoms/p-select/p-select-item.model';

@Component({
  selector: 'app-tendance-marche-immobilier-edit-mode',
  templateUrl: './tendance-marche-immobilier-edit-mode.component.html',
  styleUrls: ['./tendance-marche-immobilier-edit-mode.component.scss'],
})
export class TendanceMarcheImmobilierEditModeComponent implements OnChanges {
  @Input() tendencies!: Report.Tendencies;
  @Input() reportId!: string;

  @Output() tendenciesChanged = new EventEmitter<Report.Tendencies>();

  newTendencies!: Report.Tendencies;
  scopeItem!: PSelectItem;

  scopeSelectItems: PSelectItem[] = [
    { value: 'district', label: 'Quartier' },
    { value: 'city', label: 'Commune' },
    { value: 'epci', label: 'EPCI' },
    { value: 'departement', label: 'Département' },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    const currentTendencies = changes['tendencies']?.currentValue;
    if (currentTendencies) {
      this.newTendencies = currentTendencies;
      this.scopeItem =
        this.scopeSelectItems.find(
          (item) => item.value === currentTendencies.marketStudyScope,
        ) ?? this.scopeSelectItems[0];
    }
  }

  onInseeGraphSwitched(inseeGraph: boolean): void {
    this.newTendencies = { ...this.newTendencies, inseeGraph };
    this.tendenciesChanged.emit(this.newTendencies);
  }

  onMarketStudySwitched(marketStudy: boolean): void {
    this.newTendencies = { ...this.newTendencies, marketStudy };
    this.tendenciesChanged.emit(this.newTendencies);
  }

  onScopeSelected(item: PSelectItem): void {
    this.newTendencies = {
      ...this.newTendencies,
      marketStudyScope: item.value ?? '',
    };
    this.tendenciesChanged.emit(this.newTendencies);
  }
}
